import './Icon_Clock.css';

function Icon_Clock() {
  return (
    <div className='icon-container-clock'>
      <svg viewBox="0 0 24 24" className="responsive-svg-clock">
        <circle cx="12" cy="12" r="10"/>
        <polyline points="12,6 12,12 16,14"/>
      </svg>
    </div>
  );
}

export default Icon_Clock;